import { Typography } from "@mui/material"

export function NoLinksFound(){
    return (<Typography color="error">No links at all - check scraper</Typography>)
}

export function BufferedNewLength({ scrapReport }){
    return (<>
        { scrapReport.bufferedNew.length } buffered links
        { scrapReport.analysisResult?<> - { scrapReport.analysisResult.length } analysed links</>:<></> }
    </>)
}

export function ScrapReportLinksCount({ scrapReport }){
    return (
        <>
            <> { new Date(scrapReport.timestamp).toISOString().substring(0, 10) } </> - 
            <>
                {
                    scrapReport.old == null ? 
                    !scrapReport.linksFound?<NoLinksFound />:<><BufferedNewLength scrapReport={scrapReport}/></>:
                    (scrapReport.old.length + scrapReport.new.length + scrapReport.bufferedNew.length) == 0?<NoLinksFound />:<BufferedNewLength scrapReport={scrapReport}/>
                }
            </>
        </>
    )
}
